import React from 'react';

import { Placeholder } from 'semantic-ui-react';

export default function CardLoader() {
    return (
        <>
            <Placeholder>
                <Placeholder.Paragraph>
                    <Placeholder.Line />
                    <Placeholder.Line />
                    <Placeholder.Line />
                    <Placeholder.Line />
                </Placeholder.Paragraph>
            </Placeholder>
        </>
    );
}
